import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const HIDE_FOOTER = ['/auth', '/forgot-password', '/reset-password', '/auth/callback', '/admin', '/verify-email'];

export function AppFooter() {
  const navigate = useNavigate();
  const location = useLocation();

  if (HIDE_FOOTER.some(p => location.pathname.startsWith(p))) return null;

  return (
    <footer className="relative z-10 px-4 md:px-8 pb-28 md:pb-8 max-w-7xl mx-auto block" data-testid="app-footer">
      <div className="flex items-center justify-center gap-4 md:gap-6 py-5 border-t border-slate-200/40 flex-wrap">
        <button data-testid="footer-about" onClick={() => navigate('/about')} className="text-sm font-medium text-slate-500 hover:text-violet-600 transition-colors px-3 py-1.5 rounded-lg hover:bg-violet-50/50">About</button>
        <span className="text-slate-300 hidden md:inline">|</span>
        <button data-testid="footer-contact" onClick={() => navigate('/contact')} className="text-sm font-medium text-slate-500 hover:text-violet-600 transition-colors px-3 py-1.5 rounded-lg hover:bg-violet-50/50">Contact Us</button>
        <span className="text-slate-300 hidden md:inline">|</span>
        <button data-testid="footer-faq" onClick={() => navigate('/faq')} className="text-sm font-medium text-slate-500 hover:text-violet-600 transition-colors px-3 py-1.5 rounded-lg hover:bg-violet-50/50">FAQs</button>
        <span className="text-slate-300 hidden md:inline">|</span>
        <button data-testid="footer-privacy" onClick={() => navigate('/privacy')} className="text-sm font-medium text-slate-500 hover:text-violet-600 transition-colors px-3 py-1.5 rounded-lg hover:bg-violet-50/50">Privacy & Terms</button>
      </div>
    </footer>
  );
}
